import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React, {useEffect} from "react";
import {
    addNewRowToTable,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleChip, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage, RaikoChipTypes, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {useAuthState} from "../../context/AuthContext";
import {ElectionService} from "../../serverService/electionService/ElectionService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AddNewElections from "./AddNewElections";
import {useNavigate} from "react-router-dom";

export default function Election() {

    const [page, setPage] = useState(0);
    const size = 20;

    const [numberOfItems, setNumberOfItems] = useState("");
    const [electionData, setElectionData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [totalPage, setTotalPage] = useState(0);
    const {fundID} = useAuthState()
    const service = new ElectionService();

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getElectionListFromServer()
        }
    }, [fundID])

    function prepareGroupsJsonList(id, number, title, startPersianDate, startTime, endPersianDate, endTime, groupName, published, enabled) {
        return {
            id: id,
            number: number,
            title: title,
            startDate: startPersianDate,
            startTime: startTime,
            endDate: endPersianDate,
            endTime: endTime,
            groupName: groupName,
            published: published ? <RaikoCustomSimpleChip title={"منتشر شده"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"در انتظار انتشار"} type={RaikoChipTypes.error}/>,
            state: enabled ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getElectionListFromServer() {
        setTableLoading(true)
        service.getElectionList(fundID, page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setTotalPage(response.totalPage)
                setElectionData([])
                response.data.map((item, index) => {
                    setElectionData(prevState => [
                        ...prevState,
                        prepareGroupsJsonList(
                            item.id,
                            (page * 20) + index + 1,
                            item.title,
                            item.startPersianDate,
                            item.startPersianTime,
                            item.endPersianDate,
                            item.endPersianTime,
                            item.groupName,
                            item.published,
                            item.enabled
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const [openDialog, setOpenDialog] = useState(false);

    function handleCloseDialog() {
        setOpenDialog(false)
    }

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleAddNewElection(item) {
        const newItem = addNewRowToTable(
            prepareGroupsJsonList(
                item.id,
                (page * size) + 1,
                item.title,
                item.startPersianDate,
                item.startPersianTime,
                item.endPersianDate,
                item.endPersianTime,
                item.groupName,
                item.published,
                item.enabled
            ),
            electionData
        )
        setElectionData(newItem)
        handleCloseDialog()
    }

    const navigate = useNavigate()

    function showElectionDetails(electionId) {
        navigate(RouteHelper.ElectionDetails.globalUrl.replace(":id", electionId))
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Election.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن انتخابات جدید"}
                dialogSize={DialogSize.MEDIUM}
            >
                <AddNewElections addNewElectionsToTable={handleAddNewElection}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Election.name,
                                ""
                            )
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"انتخابات"}
                                amount={numberOfItems}
                                hasCreateNewItem={true}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={electionColumns}
                                data={electionData}
                                isLoading={tableLoading}
                                rowClicked={showElectionDetails}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const electionColumns = [
    {
        id: 'number',
        label: '#'
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'startDate',
        label: 'تاریخ شروع',
    },
    {
        id: 'startTime',
        label: 'زمان شروع',
    },
    {
        id: 'endDate',
        label: 'تاریخ پایان',
    },
    {
        id: 'endTime',
        label: 'زمان پایان',
    },
    {
        id: 'groupName',
        label: 'گروه'
    },
    {
        id: 'published',
        label: 'وضعیت انتشار'
    },
    {
        id: 'state',
        label: 'وضعیت'
    },
];
